module.exports = __webpack_public_path__ + "static/img/source_m@2x.d0e510a9.png";